import * as React from 'react';

import {PageControlBar} from 'shells/control-bar/page-control-bar';
import type {TabProps} from 'shells/control-bar/page-control-bar';

type Props = {
    tabs: TabProps;
};

export function AiTabs(props: Props) {
    return (
        <PageControlBar
            tabs={props.tabs}
            lessPadding={true}
            noHorizontalPadding={true}
            variant='ai'
            hasWhiteBackground={false}
        />
    );
}
